export enum Labels {
    AUTHENTICATION_ERROR = 'authenticationError',
    ERROR_ACCESSING_VIDEO = 'errorAccessingVideo',
    EVENT_NOT_AVAILABLE_IN_TERRITORY = 'eventNotAvailableInTerritory',
    WATCHING_VIDEO_ON_ANOTHER_DEVICE = 'watchingVideoOnAnotherDevice',
    YOURE_NOT_ALLOWED_VIDEO_FORBIDDEN = 'youreNotAllowedVideoForbidden',
    TO_WATCH_HERE_CLOSE_OTHER_SESSIONS = 'toWatchHereCloseOtherSessions',
    PLEASE_TRY_AGAIN_VIDEO_ERROR = 'pleaseTryAgainVideoError',
    REFRESH_TOKEN_EXPIRED_LOGIN_REQUIRED = 'refreshTokenExpiredLoginRequired',
    REFRESH_TOKEN_EXPIRED_REAUTHENTICATE = 'refreshTokenExpiredReauthenticate'
}
